<!-- 内閣府承認ダイアログ -->
<p-dialog
  [modal]="true"
  [(visible)]="reportDialogFlag"
  styleClass="report-dialog"
>
  <ng-template pTemplate="header">
    <div class="report-header-area">
      <label class="message1">{{ dialogLabel }}を通報する理由をご記載ください。</label>
      <span class="required">【必須】</span>
    </div>
  </ng-template>

  <!-- ダイアログコンテンツ -->
  <div
    [formGroup]="reportInputForm"
    [class.platform-large-text]="getTextSize()"
  >
    <!-- 承認拒否理由エリア -->
    <div class="report-reason-area">
      <!-- 承認拒否入力 -->
      <textarea
        pInputTextarea
        formControlName="reason"
        *ngIf="!confirmationFlag"
      ></textarea>
      <!-- 承認拒否確認 -->
      <div class="message3" *ngIf="confirmationFlag">
        {{ reportInputForm.value.reason }}
      </div>
      <!-- エラーメッセージ出力箇所 -->
      <app-validator-message [control]="reportInputForm.get('reason')" >
      </app-validator-message>
    </div>

    <!-- 入力ボタンエリア -->
    <div
      class="p-d-flex p-jc-center report-button-area"
      *ngIf="!confirmationFlag"
    >
      <button
        pButton
        type="button"
        label="決定する"
        class="button-default-size button1"
        (click)="confirmationReport()"
        [disabled]="!reportInputForm.valid"
      ></button>
    </div>

    <!-- 確認ボタンエリア -->
    <div
      class="p-d-flex p-jc-center report-button-area"
      *ngIf="confirmationFlag"
    >
      <button
        pButton
        type="button"
        label="確定する"
        class="button-default-size button1"
        (click)="insertReport()"
      ></button>
      <button
        pButton
        type="button"
        label="修正する"
        class="button-default-size button2"
        (click)="returnInputApprova()"
      ></button>
    </div>
  </div>
</p-dialog>
